export default "__VITE_ASSET__77bd63f5__"